export const isValidDateString = (testDate: string | undefined) => {
  if (!testDate) return false;
  const date_regex = /^\d{2}\/\d{2}\/\d{4}$/;
  return date_regex.test(testDate);
};
